export default {
  listTab: {
    General: {
      Name: 'GENERAL',
      Index: 1,
    },
    Notification: {
      Name: 'NOTIFICATIONS',
      Index: 2,
    },
    Contact: {
      Name: 'CONTACT',
      Index: 3,
    },
  },

  listTimeZone: [
    'greenwichMeanTime',
    'universalCoordinatedTime',
    'europeanCentralTime',
    'easternEuropeanTime',
    'egyptStandardTime',
    'easternAfricanTime',
    'middleEastTime',
    'nearEastTime',
    'pakistanLahoreTime',
    'indiaStandardTime',
    'bangladeshStandardTime',
    'vietnamStandardTime',
    'chinaTaiwanTime',
    'japanStandardTime',
    'australiaCentralTime',
    'australiaEasternTime',
    'solomonStandardTime',
    'newZealandStandardTime',
    'midwayIslandsTime',
    'hawaiiStandardTime',
    'alaskaStandardTime',
    'pacificStandardTime',
    'phoenixStandardTime',
    'mountainStandardTime',
    'centralStandardTime',
    'easternStandardTime',
    'indianaEasternStandardTime',
    'puertoRicoAndUSVIT',
    'canadaNewfoundlandTime',
    'argentinaStandardTime',
    'brazilEasternTime',
    'centralAfricanTime',
  ],

  listTimeZoneByKey: {
    greenwichMeanTime: {
      key: 'greenwichMeanTime',
      value: '(GMT) Greenwich Mean Time',
      offSet: '+00:00',
    },
    universalCoordinatedTime: {
      key: 'universalCoordinatedTime',
      value: '(GMT) Universal Coordinated Time',
      offSet: '+00:00',
    },
    europeanCentralTime: {
      key: 'europeanCentralTime',
      value: '(GMT+1:00) European Central Time',
      offSet: '+01:00',
    },
    easternEuropeanTime: {
      key: 'easternEuropeanTime',
      value: '(GMT+2:00) Eastern European Time',
      offSet: '+02:00',
    },
    egyptStandardTime: {
      key: 'egyptStandardTime',
      value: '(GMT+2:00) Egypt Standard Time',
      offSet: '+02:00',
    },

    easternAfricanTime: {
      key: 'easternAfricanTime',
      value: '(GMT+3:00) Eastern African Time',
      offSet: '+03:00',
    },
    middleEastTime: {
      key: 'middleEastTime',
      value: '(GMT+3:30) Middle East Time',
      offSet: '+03:30',
    },
    nearEastTime: {
      key: 'nearEastTime',
      value: '(GMT+4:00) Near East Time',
      offSet: '+04:00',
    },
    pakistanLahoreTime: {
      key: 'pakistanLahoreTime',
      value: '(GMT+5:00) Pakistan Lahore Time',
      offSet: '+05:00',
    },
    indiaStandardTime: {
      key: 'indiaStandardTime',
      value: '(GMT+5:30) India Standard Time',
      offSet: '+05:30',
    },

    bangladeshStandardTime: {
      key: 'bangladeshStandardTime',
      value: '(GMT+6:00) Bangladesh Standard Time',
      offSet: '+06:00',
    },
    vietnamStandardTime: {
      key: 'vietnamStandardTime',
      value: '(GMT+7:00) Vietnam Standard Time',
      offSet: '+07:00',
    },
    chinaTaiwanTime: {
      key: 'chinaTaiwanTime',
      value: '(GMT+8:00) China Taiwan Time',
      offSet: '+08:00',
    },
    japanStandardTime: {
      key: 'japanStandardTime',
      value: '(GMT+9:00) Japan Standard Time',
      offSet: '+09:00',
    },
    australiaCentralTime: {
      key: 'australiaCentralTime',
      value: '(GMT+9:30) Australia Central Time',
      offSet: '+09:30',
    },

    australiaEasternTime: {
      key: 'australiaEasternTime',
      value: '(GMT+10:00) Australia Eastern Time',
      offSet: '+10:00',
    },
    solomonStandardTime: {
      key: 'solomonStandardTime',
      value: '(GMT+11:00) Solomon Standard Time',
      offSet: '+11:00',
    },
    newZealandStandardTime: {
      key: 'newZealandStandardTime',
      value: '(GMT+12:00) New Zealand Standard Time',
      offSet: '+12:00',
    },
    midwayIslandsTime: {
      key: 'midwayIslandsTime',
      value: '(GMT-11:00) Midway Islands Time',
      offSet: '-11:00',
    },
    hawaiiStandardTime: {
      key: 'hawaiiStandardTime',
      value: '(GMT-10:00) Hawaii Standard Time',
      offSet: '-10:00',
    },

    alaskaStandardTime: {
      key: 'alaskaStandardTime',
      value: '(GMT-9:00) Alaska Standard Time',
      offSet: '-09:00',
    },
    pacificStandardTime: {
      key: 'pacificStandardTime',
      value: '(GMT-8:00) Pacific Standard Time',
      offSet: '-08:00',
    },
    phoenixStandardTime: {
      key: 'phoenixStandardTime',
      value: '(GMT-7:00) Phoenix Standard Time',
      offSet: '-07:00',
    },
    mountainStandardTime: {
      key: 'mountainStandardTime',
      value: '(GMT-7:00) Mountain Standard Time',
      offSet: '-07:00',
    },
    centralStandardTime: {
      key: 'centralStandardTime',
      value: '(GMT-6:00) Central Standard Time',
      offSet: '-06:00',
    },

    easternStandardTime: {
      key: 'easternStandardTime',
      value: '(GMT-5:00) Eastern Standard Time',
      offSet: '-05:00',
    },
    indianaEasternStandardTime: {
      key: 'indianaEasternStandardTime',
      value: '(GMT-5:00) Indiana Eastern Standard Time',
      offSet: '-05:00',
    },
    puertoRicoAndUSVIT: {
      key: 'puertoRicoAndUSVIT',
      value: '(GMT-4:00) Puerto Rico and US Virgin Islands Time',
      offSet: '-04:00',
    },
    canadaNewfoundlandTime: {
      key: 'canadaNewfoundlandTime',
      value: '(GMT-3:30) Canada Newfoundland Time',
      offSet: '-03:30',
    },
    argentinaStandardTime: {
      key: 'argentinaStandardTime',
      value: '(GMT-3:00) Argentina Standard Time',
      offSet: '-03:00',
    },
    brazilEasternTime: {
      key: 'brazilEasternTime',
      value: '(GMT-3:00) Brazil Eastern Time',
      offSet: '-03:00',
    },
    centralAfricanTime: {
      key: 'centralAfricanTime',
      value: '(GMT-1:00) Central African Time',
      offSet: '-01:00',
    },
  },

  defaultTimeZone: 'vietnamStandardTime',
  defaultTimeZoneOffset: '+07:00',
};
